import { Box } from "@chakra-ui/react";
import { LargeButton, LARGEL_BUTTON_TYPE, Spinner, useResponsive } from "goi_common";

export default function RequestUniqueFixedButton({
  handleSubmit,
  loading,
  disabled,
  isFixed = true,
  borderRadius = "0 0 10px 10px",
}: {
  handleSubmit: () => void;
  loading: boolean;
  disabled: boolean;
  isFixed?: boolean;
  borderRadius?: string;
}) {
  const { isBiggerThanMd } = useResponsive();
  return (
    <Box
      position={isFixed ? "fixed" : "relative"}
      bottom="0"
      width={isBiggerThanMd ? "480px" : "100%"}
      maxWidth={isBiggerThanMd ? "var(--global-max-width)" : "480px"}
      mt={isFixed ? "110px" : "24px"}
    >
      <LargeButton
        buttonType={disabled ? LARGEL_BUTTON_TYPE.DISABLED : LARGEL_BUTTON_TYPE.PRIMARY}
        disabled={disabled}
        borderRadius={borderRadius}
        height={60}
        onClick={handleSubmit}
      >
        <Box display="flex" maxWidth="300px">
          {loading ? <Spinner /> : "추천 받기"}
        </Box>
      </LargeButton>
    </Box>
  );
}
